// Controller actions rethrow the API message as a plain Error, so the envelope
// check alone would discard the server's reason and show the fallback instead.
export function messageFromError(err: unknown, fallback: string): string {
  const envelope = err as {
    response?: { data?: { errors?: Array<{ message?: string; detail?: string }> } };
  };
  const first = envelope.response?.data?.errors?.[0];
  const fromEnvelope = first?.message ?? first?.detail;
  if (fromEnvelope) return fromEnvelope;
  return err instanceof Error && err.message ? err.message : fallback;
}
